export interface RetiredAppInfo {
    hostName: string;
    /** Minimum host version that supports the new assistant, if known. */
    minVersion?: string;
    releaseNotesUrl?: string;
}

const HOST_RELEASE_INFO: Array<{
    match: string;
    minVersion?: string;
    releaseNotesUrl: string;
}> = [
        {
            match: "novapoint",
            minVersion: "2026.3",
            releaseNotesUrl: "https://help.trimble.com/doc/novapoint/novapoint/whats-new",
        },
        {
            match: "quadri",
            minVersion: "2026.3",
            releaseNotesUrl: "https://help.trimble.com/doc/quadri/quadri/whats-new",
        },
        {
            match: "tcom",
            releaseNotesUrl:
                "https://networkcommunity.trimble.com/product-updates?filters%5BproductArea%5D%5B0%5D=64",
        },
    ];

export function resolveRetiredAppInfo(hostName?: string): RetiredAppInfo {
    const name = hostName?.trim() ?? "";
    const lower = name.toLowerCase();
    const entry = HOST_RELEASE_INFO.find((e) => lower.includes(e.match));
    return {
        hostName: name || "the host application",
        minVersion: entry?.minVersion,
        releaseNotesUrl: entry?.releaseNotesUrl,
    };
}
